import { useSelector } from "react-redux";
import CMSDrivenPageTemplate from "../../CMSDrivenPageTemplate";
import { useParams } from "react-router-dom";
import { selectCologuardTestRedirectIsEligible } from "store/reducers/order/OrderInformationSlice";
import contentJson from "../../Content/gl-cms-help-center-2026-09-22-v2.json";
import legacyHelpCenterHome from "../../Content/gl-cms-help-center-home-2024-12-16.json";

const HELP_CENTER_HOME_ROUTE = "/content/help-center/";

const HelpCenterPage = (props) => {
  // The useParam is needed to ensure re-load on root page
  const {} = useParams();
  const isEligibleForCologuardTestRedirect = useSelector(
    selectCologuardTestRedirectIsEligible
  );

  // Check if / at the end of a URL, and if not adds it.
  // This is helpful to ensure exact match is made without much thought later
  function ensureTrailingSlash(data) {
    return data + (data.endsWith("/") ? "" : "/");
  }

  // Look through the contentJson to find the route that was provided.
  function findPageByRouteMap(pages, routeParam) {
    for (const key in pages) {
      if (pages.hasOwnProperty(key) && pages[key].route === routeParam) {
        return pages[key];
      }
    }
    return null;
  }

  const pagePathname = ensureTrailingSlash(window.location.pathname);
  const currentPage = findPageByRouteMap(contentJson.pages, pagePathname);
  // Cologuard-eligible members get the personalized resources home. Everyone
  // else, including before eligibility has loaded, keeps the previous home.
  const page =
    pagePathname === HELP_CENTER_HOME_ROUTE &&
    !isEligibleForCologuardTestRedirect
      ? legacyHelpCenterHome
      : currentPage;

  return (
    <CMSDrivenPageTemplate
      gutters={contentJson.gutters}
      pages={contentJson.pages}
      page={page}
    />
  );
};

export default HelpCenterPage;
